import { WarningRounded } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

import { VerticalStack } from '../utils/linearLayouts';

export const WarningsIcon = ({ warnings }: { warnings: { message: string }[] }) => {
    const warningStack =
        warnings.length > 0 ? (
            <VerticalStack>{warnings.map((warning) => warning.message)}</VerticalStack>
        ) : null;
    return warnings.length > 0 ? (
        <Tooltip title={warningStack}>
            <WarningRounded color='warning' />
        </Tooltip>
    ) : null;
};
